import React, { useState, useRef } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import configs from "constants/configs";
import { API_AUTH } from "service/common";
import { useSelector, useDispatch } from "react-redux";
import { Cookies } from "react-cookie";
import NoPhaiThuPrint from "components/GenericComponent/ContentPrint/NoPhaiThuPrint";
import moment from "moment";
export const BtnXuatExcel = ({ dataSearch }) => {
  const componentRef = useRef();
  const [dataPrint, setDataPrint] = useState({});
  const xuatExcel = () => () => {
    let {
      dateTo,
      code,
      customerName,
      address,
      debt,
      userName,
      trangThaiGiaHan,
      kieuvay,
      tienVay,
      typeNgayPhaiTra,
      optionDateMB,
      sapxep,
    } = dataSearch;
    const cookies = new Cookies();
    let link = configs.endPoint;
    var apilink = cookies.get("apilink");
    if (typeof apilink != "undefined" && apilink.length > 0) {
      link = apilink;
    }
    link =
      link +
      `quanlychovay/no-phai-thu-xuat-excel?tenKhachHang=${customerName}&kieuvay=${kieuvay}&tienVay=${tienVay}&maTaiSan=${code}&user=${userName}&debtLevel=${debt}&trangThaiGiaHan=${trangThaiGiaHan}&diaChi=${address}&denNgay=${dateTo}&typeNgayPhaiTra=${typeNgayPhaiTra}&sapxep=${sapxep}&optionDateMB=${optionDateMB}`;
    API_AUTH.get(link).then((res) => {
      var uri = "data:application/vnd.ms-excel," + encodeURIComponent(res.data);
      var downloadLink = document.createElement("a");
      downloadLink.href = uri;
      downloadLink.download =
        "NoPhaiThu_" + moment().format("YYYYMMDDHHmm") + ".xls";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);

      // setDataPrint(res.data);
      // console.log(res.data,"res.datares.datares.datares.data");
      // setTimeout(downExcel(), 2000);
    });
  };

  const downExcel = () => {
    // var uri =
    //     "data:application/vnd.ms-excel," +
    //     encodeURIComponent(document.getElementById("htmlExcel").outerHTML);
    // var downloadLink = document.createElement("a");
    // downloadLink.href = uri;
    // downloadLink.download =
    //     "NoPhaiThu_" + moment().format("YYYYMMDDHHmm") + ".xls";
    // document.body.appendChild(downloadLink);
    // downloadLink.click();
    // document.body.removeChild(downloadLink);
  };
  return (
    <>
      <a
        href={() => false}
        className="icon-bgnew color-print1"
        onClick={xuatExcel()}
      >
        <PopoversBootrap
          contentText="Xuất Excel"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
          <img src="/app-assets/images/icon-tai-xuong-v2.png" />
          {/* <i className="mdi mdi-download"></i> */}
        </PopoversBootrap>
      </a>
      <div style={{ display: "none", color: "#000000" }}>
        <NoPhaiThuPrint ref={componentRef} dataPrint={dataPrint} />
      </div>
    </>
  );
};
